module.exports = __webpack_public_path__ + "img/camera.79774775.png";